import { User } from '../../../../../models/User'
import { SelectOption } from '../../../../../components/SelectDropdown/SelectDropdown'
import { getUserDisplayName } from '../../common/aifeatures/utils'

export const mapUserToSelectOption = (user: User): SelectOption => {
  return {
    id: user.id,
    label: `${getUserDisplayName(user)} (${user.email})`,
  }
}
